
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CartDialog extends Serenity.EntityDialog<CartRow, any> {
        protected getFormKey() { return CartForm.formKey; }
        protected getIdProperty() { return CartRow.idProperty; }
        protected getLocalTextPrefix() { return CartRow.localTextPrefix; }
        protected getNameProperty() { return CartRow.nameProperty; }
        protected getService() { return CartService.baseUrl; }
        protected getDeletePermission() { return CartRow.deletePermission; }
        protected getInsertPermission() { return CartRow.insertPermission; }
        protected getUpdatePermission() { return CartRow.updatePermission; }

        protected form = new CartForm(this.idPrefix);

        protected updateInterface(): void {

            super.updateInterface();
            this.saveAndCloseButton.hide();
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            buttons.splice(1,2)
            buttons.push({
                title: Q.text('Make Payment'),
                cssClass: 'bg-olive',
                icon: 'fa fa-lock text-green',
                onClick: () => {
                    Q.confirm("Are you sure You want to Make Payment?", () => {

                        this.saveAndCloseButton.click();
                    });

                }
            });

           

            return buttons;
        }

        onSaveSuccess(response) {
            super.onSaveSuccess(response);
            debugger;

           // Response.CustomData
            if (response.CustomData != null) {
                var orders = response.CustomData;
                const userRoles: { [key: string]: object } = response.CustomData;
                const order = response.CustomData[0];
                
                const orderIdValue = userRoles["OrderId"];
                const value = orders.OrderId;
                //var dlg = new RioERP.Orders.FranchiseeOrdersDialog();
                ////var rd = JSON.stringify(value);
                //dlg.loadByIdAndOpenDialog(value);
                Q.notifySuccess("Order Placed Successfully,Procced to payment");
                this.dialogClose();
                var param = {
                    'OrderId': value
                };
                var url = "/Orders/PayWithEaseBuzz";
                debugger;
                this.OpenWindowWithPostData(url, "", "PaymentGateway", param);
            }

        }

        protected OpenWindowWithPostData(url, windowoption, name, params) {
            var form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", url);
            form.setAttribute("target", name);
            for (var i in params) {
                if (params.hasOwnProperty(i)) {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = i;
                    input.value = params[i];
                    form.appendChild(input);
                }
            }
            document.body.appendChild(form);
            window.open(url, name, windowoption);
            form.submit();
            document.body.removeChild(form);
        }

        }
    }
